import * as React from 'react';

import AkCrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import AkErrorIcon from '@atlaskit/icon/core/status-error';
import AkInfoIcon from '@atlaskit/icon/core/status-information';
import AKCheckCircleIcon from '@atlaskit/icon/core/status-success';
import AkWarningIcon from '@atlaskit/icon/core/status-warning';
import type { NewCoreIconProps } from '@atlaskit/icon/types';
import { token } from '@atlaskit/tokens';

export const createErrorIcon = (): React.FunctionComponentElement<NewCoreIconProps> =>
	React.createElement(AkWarningIcon, {
		label: '',
		color: token('color.icon.warning'),
	});
export const createDangerIcon = (): React.FunctionComponentElement<NewCoreIconProps> =>
	React.createElement(AkWarningIcon, {
		label: '',
		color: token('color.icon.accent.red'),
	});
export const createRhombusErrorIcon = (): React.FunctionComponentElement<NewCoreIconProps> =>
	React.createElement(AkErrorIcon, {
		label: '',
		color: token('color.icon.danger'),
		testId: 'adminhub-error-package-rombus-error-icon',
	});
export const createSuccessIcon = (): React.FunctionComponentElement<NewCoreIconProps> =>
	React.createElement(AKCheckCircleIcon, {
		label: '',
		color: token('color.icon.success'),
		testId: 'adminhub-error-package-success-icon',
	});
export const createErrorCrossIcon = (): React.FunctionComponentElement<NewCoreIconProps> =>
	React.createElement(AkCrossCircleIcon, {
		label: '',
		color: token('color.icon.accent.red'),
	});
export const createInfoIcon = (): React.FunctionComponentElement<NewCoreIconProps> =>
	React.createElement(AkInfoIcon, {
		label: '',
		color: token('color.icon.brand'),
	});
